<ion-header [translucent]="true">

    <ion-toolbar class="ion-padding-end">
        <ion-title slot="start">{{Title}}</ion-title>
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>

</ion-header>

<ion-content class="ion-padding padding-horizontal">

    <ion-grid class="ion-no-padding ion-no-margin table" *ngIf="Data?.length > 0">

        <ion-row class="table-header">
            <ion-col class="flex-align-center" i18n=":@@household_history_table.name">Nome</ion-col>
            <ion-col size="3" class="flex-align-center" i18n=":@@household_history_table.card">Nº Cartão</ion-col>
            <ion-col size="2" class="flex-align-center" i18n=":@@household_history_table.status">Estado</ion-col>
            <ion-col size="2" class="flex-align-center ion-hide-xl-down"
                i18n=":@@household_history_table.date">Associado em</ion-col>
            <ion-col class="flex-align-center flex-justify-end buttons-size-3"></ion-col>
        </ion-row>

        <ng-container *ngFor="let item of Data">

            <ion-row class="table-body clickable" (click)="OnToggle(item)">

                <ion-col class="flex-align-center">{{item?.PersonalData?.Name || '--'}}</ion-col>

                <ion-col size="3" class="flex-align-center">{{CardNumber(item?.WalletCard?.Number)}}</ion-col>

                <ion-col size="2" class="flex-align-center">{{item?.Status?.Name || '--'}}</ion-col>

                <ion-col size="2" class="flex-align-center ion-hide-xl-down">
                    <date-tooltip [date]="item?.RegistDate"></date-tooltip>
                </ion-col>

                <ion-col class="flex-justify-end buttons-size-3">
                    <ion-button fill="clear" size="small" (click)="OnViewMember($event, item)" title="Ver perfil">
                        <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" size="small" *ngIf="item?.StatusHistoricList?.length > 0">
                        <ion-icon [name]="IsExpanded(item) ? 'chevron-up-outline' : 'chevron-down-outline'"
                            slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-col>

            </ion-row>

            <!-- uma ion-row por entrada, com as mesmas colunas da tabela, para alinhar
                 debaixo de Estado/Associado em em vez de encostar às margens -->
            <ion-row class="table-body history-detail" *ngFor="let entry of item?.StatusHistoricList"
                [hidden]="!IsExpanded(item)">

                <ion-col class="flex-align-center"></ion-col>

                <ion-col size="3" class="flex-align-center"></ion-col>

                <ion-col size="2" class="flex-align-center">{{entry?.Name}}</ion-col>

                <ion-col size="2" class="flex-align-center ion-hide-xl-down">
                    {{(entry?.RegistDate | date: 'dd/MM/yyyy HH:mm') || '--'}}
                </ion-col>

                <ion-col class="flex-align-center flex-justify-end buttons-size-3"></ion-col>

            </ion-row>

        </ng-container>

    </ion-grid>

    <no-items *ngIf="Data?.length == 0" description="Sem histórico"></no-items>

</ion-content>
